<section class="upload_error__action">
  <via-retake-interview-button *ngIf="showRetakeInterview"></via-retake-interview-button>
  <via-retry-upload-button *ngIf="showRetryUpload"></via-retry-upload-button>
</section>
